import * as React from "react";

import { Plan } from "./Chapters";

export default () => {
  return <Plan method="PATCH" />;
};
